var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanJoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 257,
    viewBox: "0 0 409 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 137.838,
    ry: 137.473,
    transform: "matrix(-0.998993 -0.0448745 -0.0448745 0.998993 258.683 155.877)",
    fill: "url(#paint0_linear_1997_1453)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M335.804 60.7668L352.925 44.8604L368.82 62.2499L351.466 77.3391L335.804 60.7668Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M236.71 219.037L238 190.316L320.877 193.347L322.266 206.474C337.518 332.026 368.745 376.457 455.769 419.839L438.968 464.539C347.709 420.977 302.166 388.31 278.84 245.136C224.664 297.352 216.178 352.773 224.978 480.209L173.71 477.906C172.179 332.179 182.237 269.121 236.71 219.037Z",
    fill: "#3E355C",
    stroke: "#3E355C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306.827 196.904C319.646 339.725 347.168 395.304 445.394 435.242",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M396.246 266.009C396.82 245.789 396.554 236.439 394.918 223.723L361.184 226.242C359.53 241.384 359.861 248.642 362.934 259.134C364.403 261.528 365.286 261.546 366.961 259.315C366.913 254.699 367.051 252.195 368.529 248.358C369.754 246.795 370.401 246.859 371.481 248.49C373.834 258.564 375.046 262.283 377.104 267.032C378.576 268.804 379.346 268.927 380.593 267.189L381.184 254.037C381.682 253.301 381.973 253.184 382.526 254.097L384.619 267.37C386.194 269.729 387.124 269.982 388.914 267.563L389.505 254.41C389.964 253.549 390.215 253.201 390.578 254.459C390.578 254.459 392.388 262.071 393.025 265.865C393.661 269.659 395.286 269.672 396.246 266.009Z",
    fill: "white",
    stroke: "#3E355C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M262.315 74.1414C266.396 68.4551 269.149 66.0112 275.169 63.4224L278.927 63.5912L289.667 69.9908L291.564 81.6413L289.239 91.4884L287.997 119.136L292.023 119.316L274.806 137.37L267.633 117.414L271.391 117.583L271.475 91.7663C265.533 87.9657 263.864 85.0044 264.843 77.7514C264.384 76.4598 263.956 75.6972 262.315 74.1414Z",
    fill: "white",
    stroke: "#3E355C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M295.642 68.8761C298.321 77.7828 296.861 82.683 292.263 88.5987C290.528 90.8315 287.033 91.058 285.538 88.6578C284.967 87.7416 284.498 86.7189 284.095 85.447C283.629 83.9784 284.444 82.4428 285.851 81.8164C286.426 81.5603 286.929 81.1503 287.233 80.5987C288.338 78.592 288.05 77.37 285.539 76.1241C284.516 75.617 283.811 74.6024 283.863 73.4623C283.9 72.6377 283.548 71.8434 282.913 71.3163L275.394 65.0766C274.696 64.4973 274.163 63.7394 273.882 62.8772C271.885 56.7632 272.429 54.7167 275.991 54.4004C276.603 54.3461 277.217 54.4645 277.791 54.6837C285.844 57.761 289.858 60.6682 294.917 67.4429C295.239 67.8737 295.487 68.3611 295.642 68.8761Z",
    fill: "#3E355C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M237.769 189.499L320.979 193.236L322.235 165.254C344.477 177.72 352.783 195.012 360.392 225.937L395.211 223.198C378.954 161.854 364.026 132.46 292.036 119.048L274.794 137.639L267.145 116.316C250.374 117.033 244.01 122.199 238.377 140.037L237.769 189.499Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M237.769 189.499L320.979 193.236L322.235 165.254C315.067 160.75 310.215 159.096 300.864 156.023C339.932 169.361 350.724 186.647 360.392 225.937L395.211 223.198C378.954 161.854 364.026 132.46 292.036 119.048L274.794 137.639L267.145 116.316C250.374 117.033 244.01 122.199 238.377 140.037L237.769 189.499Z",
    stroke: "#3E355C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M238.692 138.976C196.183 161.757 187.129 131.28 180.067 66.9506C167.326 73.4979 160.235 76.5581 147.73 80.2908C150.715 95.7129 150.195 113.753 155.003 127.955C171.124 175.57 188.691 187.822 237.958 179.287L238.692 138.976Z",
    fill: "white",
    stroke: "#3E355C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144.761 67.797C145.133 70.4105 146.498 73.5556 148.527 77.8576C159.318 74.5 166.043 71.7447 177.157 65.9167C175.054 59.1563 170.975 52.4438 164.612 45.7615C158.566 40.3931 153.072 37.5726 148.72 36.8098C145.271 36.2051 142.648 36.8862 140.837 38.5282L148.444 44.9431C149.239 45.6131 149.388 46.7799 148.787 47.628L145.766 51.8937C146.161 54.0226 146.478 55.4301 146.79 56.4115C147.132 57.4852 147.415 57.8647 147.635 58.078C148.039 58.4703 148.26 59.0153 148.242 59.5788C148.223 60.1423 147.968 60.6719 147.539 61.0373C146.205 62.172 145.456 63.2307 145.06 64.2554C144.666 65.2742 144.563 66.41 144.761 67.797Z",
    fill: "white",
    stroke: "#3E355C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M178.552 40.7932C179.621 42.9425 179.857 44.1965 178.287 46.6984C172.409 46.6517 167.133 46.5645 162.43 46.4358C157.025 43.4012 152.945 43.2538 150.081 45.9283C140.458 45.36 134.76 44.4877 132.448 43.2945C138.476 38.5854 154.879 40.0036 178.552 40.7932Z",
    fill: "#3E355C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.241 67.8526C157.527 64.7995 157.257 63.0322 160.554 58.2739C162.467 54.8768 162.494 53.3228 158.965 51.7474L147.591 47.4711C152.414 41.9829 156.853 42.844 165.904 46.9489",
    stroke: "#3E355C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.334 47.1908C145.289 47.4435 144.201 48.2023 142.346 50.4632C139.326 55.3081 138.85 57.8785 143.45 61.8091L148.146 59.0615C145.25 55.4825 144.914 53.1556 147.286 48.2644L147.334 47.1908Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M148.146 59.0615C145.25 55.4825 144.914 53.1556 147.286 48.2644L147.334 47.1908C145.289 47.4435 144.201 48.2023 142.346 50.4632C139.326 55.3081 138.85 57.8785 143.45 61.8091L148.146 59.0615ZM148.146 59.0615C150.705 57.921 151.756 56.9808 153.913 50.4256",
    stroke: "#3E355C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1997_1453",
    x1: 206.36,
    y1: -116.531,
    x2: 212.199,
    y2: 236.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E355C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B29D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanJoin);
export default __webpack_public_path__ + "static/media/can_join.0c7e88a5cce3eb7415dba05054673815.svg";
export { ForwardRef as ReactComponent };